import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import connect from 'app/libs/connect';
import { helpCenterLocales } from 'app/router/constants/routerLocales';
import { userLocale } from 'app/features/user/selectors';
import S from 'app/features/helpCenter/components/HelpCenter.styled';
import BasicLink from 'app/components/Links/BasicLink.styled';
import Heading from 'app/components/layout/Heading.styled';
import Text from 'app/components/layout/Text.styled';
import { helpCenterClicked } from 'app/features/helpCenter/actions';

const UI = ({ locale, helpCenterClicked, article }) => (
  <S.HelpCenter data-t="helpcenter-block">
    <Heading size="l" as={S.HelpCenter.Title}>
      <FormattedMessage id="help_center_title" />
    </Heading>
    <Text as={S.HelpCenter.Subtitle} size="xl">
      <FormattedMessage
        id="help_center_subtitle"
        values={{
          helpCenterCta: (
            <BasicLink
              href={`https://help.crunchyroll.com/hc${helpCenterLocales[locale]}${article}`}
              data-t="help-center-external"
              onClick={() => helpCenterClicked()}
              target="_blank"
            >
              <FormattedMessage id="help_center_subtitle_cta" />
            </BasicLink>
          ),
        }}
      />
    </Text>
  </S.HelpCenter>
);

UI.propTypes = {
  locale: PropTypes.string,
  article: PropTypes.string,
  helpCenterClicked: PropTypes.func.isRequired,
};

UI.defaultProps = {
  locale: 'enUS',
  article: '',
};

UI.displayName = 'HelpCenter';

const state = { locale: userLocale };

const HelpCenter = connect(state, { helpCenterClicked })(UI);

export { UI };

export default HelpCenter;
